"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _focusTrapReact = _interopRequireDefault(require("focus-trap-react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _Portal = _interopRequireDefault(require("../helpers/Portal"));
var _useStencilPxtTelemetry = require("../pxt-telemetry/useStencilPxtTelemetry");
var _context = require("../context");
var _helpers = require("../helpers");
var _layout = require("../layout");
var _pxtTelemetry = require("../pxt-telemetry");
var _responsive = require("../responsive");
var _utils = require("../utils");
var _PopoverController = _interopRequireDefault(require("./PopoverController"));
var _constants = require("./constants");
var _propTypes = require("./propTypes");
var _utils2 = require("./utils");
var _core = require("@emotion/core");
var _excluded = ["children", "triggerText", "position", "shouldFocusOnOpen", "shouldCloseOnFocusLeave", "maxWidth", "triggerButtonProps", "contentProps", "onOpened", "onClosed", "aria-haspopup"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var PopoverWithoutDocs = function PopoverWithoutDocs(_ref) {
  var children = _ref.children,
    triggerText = _ref.triggerText,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? _constants.PopoverDefaultProps.position : _ref$position,
    _ref$shouldFocusOnOpe = _ref.shouldFocusOnOpen,
    shouldFocusOnOpen = _ref$shouldFocusOnOpe === void 0 ? _constants.PopoverDefaultProps.shouldFocusOnOpen : _ref$shouldFocusOnOpe,
    _ref$shouldCloseOnFoc = _ref.shouldCloseOnFocusLeave,
    shouldCloseOnFocusLeave = _ref$shouldCloseOnFoc === void 0 ? _constants.PopoverDefaultProps.shouldCloseOnFocusLeave : _ref$shouldCloseOnFoc,
    maxWidthProp = _ref.maxWidth,
    _ref$triggerButtonPro = _ref.triggerButtonProps,
    triggerButtonProps = _ref$triggerButtonPro === void 0 ? _constants.PopoverDefaultProps.triggerButtonProps : _ref$triggerButtonPro,
    passedContentProps = _ref.contentProps,
    _onOpened = _ref.onOpened,
    onClosed = _ref.onClosed,
    ariaHasPopup = _ref['aria-haspopup'],
    forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useContext = (0, _react.useContext)(_context.StencilPopoverContext),
    setHasOpenedPopover = _useContext.setHasOpenedPopover;
  var target = (0, _react.useRef)(null);
  var viewport = (0, _responsive.useBreakpoints)();
  var isSmallViewport = viewport.matches.s;
  var initialFocusRef = (0, _react.useRef)(null);
  var parentRef = (0, _react.useRef)(null);
  var handleSetIsOpen = function handleSetIsOpen(value) {
    setIsOpen(value);
    setHasOpenedPopover(value);
  };
  var handleToggle = function handleToggle() {
    handleSetIsOpen(!isOpen);
  };
  var handleClose = function handleClose() {
    if (isDialogPattern) (0, _utils.changeAriaHiddenOnSiblings)(parentRef.current, false);
    handleSetIsOpen(false);
  }; // The `role` of the content must match the value of `aria-haspopup`.
  // Special case: `true` or "true" must be treated as "menu"
  // https://www.w3.org/TR/wai-aria/#aria-haspopup

  var contentRole;
  switch (ariaHasPopup) {
    case true:
    case 'true':
    case 'menu':
      contentRole = _constants.MENU_CONTENT_ROLE;
      break;
    default:
      contentRole = 'dialog';
  }
  var isDialogPattern = shouldFocusOnOpen && contentRole === 'dialog';
  var defaultMaxWidth = isSmallViewport ? _constants.MAX_WIDTH_SMALL_VIEWPORT : _constants.MAX_WIDTH_LARGE_VIEWPORT;
  var maxWidth = maxWidthProp === null ? undefined : maxWidthProp || defaultMaxWidth;
  var maxHeight = isSmallViewport ? _constants.MAX_HEIGHT_SMALL_VIEWPORT : _constants.MAX_HEIGHT_LARGE_VIEWPORT;
  var ariaHasPopupAttribute = contentRole === _constants.MENU_CONTENT_ROLE ? {
    'aria-haspopup': ariaHasPopup
  } : {}; // 'aria-describedby' should be used by the consumers in triggerButtonProps.

  var triggerPatternProps = isDialogPattern ?
  // Dialog pattern: https://www.w3.org/TR/wai-aria-practices-1.2/#dialog_modal.
  {
    shouldSetAriaExpanded: false
  } :
  // Disclosure button pattern: https://www.w3.org/TR/wai-aria-practices-1.2/#disclosure.
  // Adding aria-haspopup for the menu button.
  _objectSpread(_objectSpread({}, ariaHasPopupAttribute), {}, {
    'aria-expanded': isOpen,
    shouldSetAriaExpanded: true
  });
  var contentPatternProps = shouldFocusOnOpen ? {
    role: contentRole,
    'aria-modal': contentRole === _constants.MENU_CONTENT_ROLE ? undefined : true,
    tabIndex: contentRole === _constants.MENU_CONTENT_ROLE ? undefined : -1
  } : {};
  var contentProps = _objectSpread(_objectSpread(_objectSpread({
    dataTestComponent: 'StencilPopoverContent',
    padding: _constants.CONTENT_PADDING,
    maxWidth: maxWidth,
    maxHeight: maxHeight,
    overflow: 'auto'
  }, passedContentProps), contentPatternProps), {}, {
    children: children({
      close: handleClose
    })
  });
  var _useStencilPXTTelemet = (0, _useStencilPxtTelemetry.useStencilPXTTelemetryPortalPatch)(),
    _useStencilPXTTelemet2 = (0, _slicedToArray2.default)(_useStencilPXTTelemet, 2),
    pxtTelemetryPath = _useStencilPXTTelemet2[0],
    pxtTelemetryTargetRef = _useStencilPXTTelemet2[1];
  var forwardedPXTTelemetryProps = (0, _pxtTelemetry.exposePxtTelemetryDataProps)(forwardedProps);
  var popoverController = (0, _core.jsx)(_PopoverController.default, {
    target: target,
    close: handleClose,
    onClosed: onClosed,
    onOpened: function onOpened() {
      if (isDialogPattern) (0, _utils.changeAriaHiddenOnSiblings)(parentRef.current, true);
      if (!!_onOpened) _onOpened();
    },
    isOpen: isOpen,
    position: position,
    shouldFocusOnOpen: shouldFocusOnOpen,
    shouldCloseOnFocusLeave: isDialogPattern ? false : shouldCloseOnFocusLeave
  }, isDialogPattern ? (0, _core.jsx)(_focusTrapReact.default, {
    focusTrapOptions: {
      delayInitialFocus: false,
      initialFocus: function initialFocus() {
        return initialFocusRef.current;
      },
      fallbackFocus: function fallbackFocus() {
        return (0, _core.jsx)("div", {
          tabIndex: -1
        });
      },
      escapeDeactivates: true,
      clickOutsideDeactivates: (0, _utils2.handlePopoverClickOutside)(target.current, handleClose),
      onDeactivate: handleClose,
      preventScroll: true
    }
  }, (0, _core.jsx)("div", pxtTelemetryPath, (0, _core.jsx)(_layout.View, (0, _extends2.default)({
    ref: initialFocusRef
  }, contentProps)))) : (0, _core.jsx)(_layout.View, contentProps));
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_helpers.TriggerButton, (0, _extends2.default)({}, triggerPatternProps, triggerButtonProps, {
    onClick: handleToggle,
    isExpanded: isOpen,
    ref: target
  }, (0, _utils.pickDataProps)(forwardedProps)), triggerText), isDialogPattern ? (0, _core.jsx)("div", (0, _extends2.default)({
    ref: pxtTelemetryTargetRef
  }, forwardedPXTTelemetryProps, {
    "data-test-component": "StencilPopoverContainer" // To avoid edge case related to the css flex wrapping it
    ,

    style: {
      display: 'none'
    }
  }), (0, _core.jsx)(_Portal.default, null, (0, _core.jsx)("div", {
    ref: parentRef
  }, popoverController))) : popoverController);
};
var PopoverWithDocs = (0, _stencilReactDesc.describe)(PopoverWithoutDocs).description('Displays a popover attached to a trigger button.');
PopoverWithDocs.propTypes = _objectSpread({}, _propTypes.popoverPropTypes);
PopoverWithDocs.defaultProps = _objectSpread({}, _constants.PopoverDefaultProps);
var Popover = (0, _utils.withTestAttributes)({
  component: 'StencilPopoverTrigger'
})(PopoverWithDocs);
Popover.displayName = 'Popover';
var _default = Popover;
exports.default = _default;